import React, { useState, useEffect } from "react";
import BuyerSidebar from "./common/BuyerSidebar";
import { Link } from "react-router-dom";
import OrderCard from "./comoponent/OrderCard";
import CommanPagination from "../pages/common/CommanPagination/CommanPagination";
import ProfileSidebar from "../pages/common/ProfileSidebar";

const MyOrders = () => {
  const orders = [
    {
      orderId: "WT858589",
      productName: "Woolen clothes for elders",
      productImage: "/images/woolen_cloths.jpg",
      productBy: "YMCA Foundation",
      price: 200,
      quantity: 1,
      status: "Confirmed",
      deliveryDate: "19 Aug 2025",
      trackingId: "WT764785",
    },
    {
      orderId: "WT858589",
      productName: "Woolen clothes for elders",
      productImage: "/images/woolen_cloths.jpg",
      productBy: "YMCA Foundation",
      price: 200,
      quantity: 1,
      status: "Confirmed",
      deliveryDate: "19 Aug 2025",
      trackingId: "WT764785",
    },
    {
      orderId: "WT858589",
      productName: "Woolen clothes for elders",
      productImage: "/images/woolen_cloths.jpg",
      productBy: "YMCA Foundation",
      price: 200,
      quantity: 1,
      status: "Confirmed",
      deliveryDate: "19 Aug 2025",
      trackingId: "WT764785",
    },
    {
      orderId: "WT858589",
      productName: "Woolen clothes for elders",
      productImage: "/images/woolen_cloths.jpg",
      productBy: "YMCA Foundation",
      price: 200,
      quantity: 1,
      status: "Confirmed",
      deliveryDate: "19 Aug 2025",
      trackingId: "WT764785",
    },
    {
      orderId: "WT858589",
      productName: "Woolen clothes for elders",
      productImage: "/images/woolen_cloths.jpg",
      productBy: "YMCA Foundation",
      price: 200,
      quantity: 1,
      status: "Confirmed",
      deliveryDate: "19 Aug 2025",
      trackingId: "WT764785",
    },
  ];

  // 🔹 Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(4); // show 3 cards per page

  const totalCounts = orders.length;
  const totalPage = Math.max(1, Math.ceil(totalCounts / limit));
  const startIndex = (currentPage - 1) * limit;
  const currentOrders = orders.slice(startIndex, startIndex + limit);

  useEffect(() => {
    // Reset to first page if limit changes
    setCurrentPage(1);
  }, [limit]);

  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
            <div className="bradcams mb_view_hide">
              <span className="bothss">
                <Link to="">My Account</Link>{" "}
                <img src="/images/brd_rowwo.png" alt="" /> Orders
              </span>
            </div>
            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <ProfileSidebar />
              </div>
              <div className="col-lg-9 my_orders">
                <div
                  className="d-flex justify-content-between align-items-center mb-3"
                  style={{ gap: "12px" }}
                >
                  <h5 className="">My Orders</h5>
                  <button className="btn-filter order-filter">
                    <img src="/images/mage_filter.png" alt="filter" /> Filter
                  </button>
                </div>

                {/* 🔹 Paginated Orders */}
                {currentOrders.map((order) => (
                  <OrderCard key={order.orderId} {...order} />
                ))}

                {/* 🔹 Pagination Component */}
                <div className="pages_liststs">
                  <CommanPagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    limit={limit}
                    totalCounts={totalCounts}
                    totalPage={totalPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MyOrders;
